import { memo } from 'react'
import { Field } from 'react-final-form'
import { Checkbox } from '@cargomart/ui'
import cn from 'classnames'
import { required } from 'forms'

import { CONSEST_DATA_PERSONAL_DOC_ACTUAL, PROVISION_OF_FREIGHT_FORWARDING_SERVICES_ACTUAL } from '../../constants'

interface IProps {
  className?: string
}

const linkClassName = cn(
  'decoration-none relative text-on-surface-link',
  'border-b border-solid border-on-surface-link/[.30]',
  'hover:border-on-surface-link',
  'focus:border-on-surface-link'
)

export const OrderCreateAgreeOffer = memo<IProps>(function OrderCreateAgreeOffer({ className }) {
  return (
    <Field name="isAgreeOffer" type="checkbox" validate={required}>
      {({ meta, input }) => (
        <Checkbox
          checked={input.checked === true}
          className={cn(className, 'items-center justify-start bg-[#fff] [&>span]:min-w-[22px]')}
          invalid={meta.error && meta.touched}
          name="isAgreeOffer"
          onChange={() => {
            input.onChange(!input.checked)
          }}
        >
          <div className={meta.error && meta.touched ? 'text-negative' : ''}>
            <span>Продолжая, вы подтверждаете, что ознакомлены и согласны с условиями </span>
            <a
              href={PROVISION_OF_FREIGHT_FORWARDING_SERVICES_ACTUAL}
              rel="noreferrer"
              target="_blank"
              className={linkClassName}
            >
              договора-оферты
            </a>
            <span> и даёте согласие на </span>
            <a href={CONSEST_DATA_PERSONAL_DOC_ACTUAL} rel="noreferrer" target="_blank" className={linkClassName}>
              обработку персональных данных
            </a>
          </div>
        </Checkbox>
      )}
    </Field>
  )
})
